import { useEffect, type ReactNode } from 'react';
import { useAuth } from './MidwayAuthContext';

/**
 * Gates its children behind a valid Midway session. While the session is being
 * resolved a lightweight loading state is shown. Unauthenticated users are
 * redirected to Midway sign-in.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, signIn } = useAuth();

  useEffect(() => {
    if (status === 'unauthenticated') {
      signIn();
    }
  }, [status, signIn]);

  if (status === 'authenticated') {
    return <>{children}</>;
  }

  return (
    <div className="auth-gate">
      <div className="auth-gate__card">
        <div className="auth-gate__spinner" aria-hidden />
        <p className="auth-gate__text">
          {status === 'loading'
            ? 'Verifying your Midway session...'
            : 'Redirecting to Midway sign-in...'}
        </p>
      </div>
    </div>
  );
}
